"use strict";

import $ from "jquery";

export default function gotoTop(scope) {
    $(scope).each(function () {
        $(window).scroll(() => {
            const scrolled =
                100 -
                ($(window).scrollTop() /
                    ($(document).height() - $(window).height())) *
                    100;

            if (scrolled < 80) {
                $(this).addClass("goto-top--visible");
            } else {
                $(this).removeClass("goto-top--visible");
            }
        });

        $(this).on("click", () => {
            $("html, body").animate(
                {
                    scrollTop: 0,
                },
                300,
            );
        });
    });
}
